<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllLoading"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>

            <v-list>
              <v-list-tile
                @click="
                  printAllAccountReceivableReport('accountReceiableReport')
                "
              >
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile
                @click="accountReceivableReportByCustomerExportAll()"
              >
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="customerCode"
                label="Customer Code"
                type="text"
                v-model="queryParams.customerCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="customerName"
                label="Customer Name"
                type="text"
                v-model="queryParams.customerName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Credit Amount:</span>
              <v-chip>
                <span>{{ totalCreditAmount | decFormat(6) }}</span>
              </v-chip>

              <span>Total Credit Paid Amount:</span>
              <v-chip>
                <span>{{ totalCreditPaidAmount | decFormat(6) }}</span>
              </v-chip>

              <span>Total Remaining Amount:</span>
              <v-chip>
                <span>{{ totalRemainingAmount | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="accountReceivableReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.customerCode }}</td>
              <td>{{ props.item.customerName }}</td>
              <td>{{ props.item.customerAddress }}</td>
              <td style="text-align: right">
                {{ props.item.creditAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.creditPaidAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.remainingAmount | decFormat(6) }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!--print all-->
    <div
      id="accountReceiableReport"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">
          Account Receivable Report By Customer
        </p>
      </div>
      <br />
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From Date: [{{ queryParams.fromDate }}] To Date: [{{
            queryParams.toDate
          }}]
        </p>
      </div>
      <br />
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Reported Date: [{{ reportedDate }}]
        </p>
      </div>
      <br />
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Customer Code
              </th>
              <th style="border: 1px solid black; text-align: center">
                Customer Name
              </th>
              <th style="border: 1px solid black; text-align: center">
                Address
              </th>
              <th style="border: 1px solid black; text-align: center">
                Credit Amount
              </th>
              <th style="border: 1px solid black; text-align: center">
                Credit Paid Amount
              </th>
              <th style="border: 1px solid black; text-align: center">
                Remaining Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allAccountReceivableList" :key="index">
              <td style="border: 1px solid black; text-align: left">
                {{ item.customerCode }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.customerName }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.customerAddress }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.creditAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.creditPaidAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.remainingAmount | decFormat(6) }}
              </td>
            </tr>
            <tr style="border: 1px solid black; text-align: right">
              <td
                style="border: 1px solid black; font-weight: bold"
                colspan="3"
              >
                Grand Total
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ totalCreditAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ totalCreditPaidAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ totalRemainingAmount | decFormat(6) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { accountReceivableService } from "../../services/account-receivable-service";

export default {
  name: "AccountReceivableReportByCustomer",
  components: {},
  data: () => ({
    showListLoading: false,
    printAllLoading: false,
    showFilters: false,
    show: false,
    reportedDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Sale Reports",
        disabled: true,
      },
      {
        text: "Account Receivable Report By Customer",
        disabled: true,
      },
    ],
    headers: [
      { text: "Customer Code", align: "left", value: "temp.customerCode" },
      { text: "Customer Name", align: "left", value: "temp.customerName" },
      { text: "Address", align: "left", sortable: false },
      { text: "Credit Amount", align: "left", value: "creditAmount" },
      { text: "Credit Paid Amount", align: "left", value: "creditPaidAmount" },
      {
        text: "Remaining Amount",
        align: "left",
        value: "temp.remainingAmount",
      },
    ],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "temp.customerCode",
      totalItems: 0,
    },
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      customerCode: "",
      customerName: "",
    },
    rowsPerPageItems: [25, 50, 100],
    clonequeryParams: new Object(),
    accountReceivableReportList: [],
    allAccountReceivableList: [],
    totalRows: 0,
    totalCreditAmount: 0,
    totalCreditPaidAmount: 0,
    totalRemainingAmount: 0,
  }),
  watch: {
    pagination: {
      handler() {
        this.getAccountReceivableReportByCustomer();
        this.getAccountReceivableReportByCustomerSummary();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.code = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.customerCode) {
      this.queryParams.customerCode = this.$route.query.customerCode;
    }
    if (this.$route.query.customerName) {
      this.queryParams.customerName = this.$route.query.customerName;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.decimalFormat = commonService.formatdecimal();
    this.onSearch();
  },
  methods: {
    getAccountReceivableReportByCustomer() {
      this.accountReceivableReportList = [];
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      accountReceivableService
        .getAccountReceivableReportByCustomer(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.accountReceivableReportList =
              res.data.accountReceivableReportByCustomerList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getAccountReceivableReportByCustomerSummary() {
      accountReceivableService
        .getAccountReceivableReportByCustomerSummary(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.totalCreditAmount = res.data.totalCreditAmount;
            this.totalCreditPaidAmount = res.data.totalCreditPaidAmount;
            this.totalRemainingAmount = res.data.totalRemainingAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "account-receivable-report-by-customer",
        query: this.queryParams,
      });
      this.getAccountReceivableReportByCustomer();
      this.getAccountReceivableReportByCustomerSummary();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
    },
    printAllAccountReceivableReport(divName) {
      this.printAllLoading = true;
      this.allAccountReceivableList = [];
      accountReceivableService
        .getAccountReceivableReportByCustomerPrint(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allAccountReceivableList =
              res.data.accountReceivableReportByCustomerList;
            this.totalCreditAmount = res.data.totalCreditAmount;
            this.totalCreditPaidAmount = res.data.totalCreditPaidAmount;
            this.totalRemainingAmount = res.data.totalRemainingAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllLoading = false;
        });
    },
    accountReceivableReportByCustomerExportAll() {
      this.printAllLoading = true;
      accountReceivableService
        .getAccountReceivableReportByCustomerExcelExport(this.clonequeryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllLoading = false;
        });
    },
  },
};
</script>